// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  height: 100%;
  background: transparent;
  z-index: 1;
  position: relative;
  width: 100vw;
  position: relative;
  margin: 0 auto;
}

.subBox {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  padding: 0;
  margin: 0;
  overflow: visible;
  min-width: 100%;
  max-width: 100%;
  border-radius: 0px;
  background-color: rgba(255, 255, 255, 0);
  box-sizing: content-box;
  transition: all 0.5s ease-in-out;
  box-shadow: none;
  flex-direction: column;
  gap: 5vw;
}
.subBox .contentInner {
  padding: 3vw;
  background: linear-gradient(40deg, hsl(var(--drop-color-primary)/0.2) 0%, hsl(var(--drop-dark-primary)/0.3) 50%, hsl(var(--drop-color-primary)/0.2) 100%);
  backdrop-filter: blur(3px);
  -webkit-backdrop-filter: blur(3px);
  border: 1px solid var(--ion-light-secondary);
  background-color: rgba(255, 255, 255, 0);
  display: flex;
  overflow: auto;
  position: relative;
  justify-content: center;
  transition: all 0.5s ease-in-out;
  flex-direction: column;
  margin: 0 auto;
  width: 92vw;
  border-radius: 20px;
  gap: 3vw;
}
.subBox .contentInner .profileInfo {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  transition: all 0.5s ease-in-out;
  margin: 0;
  padding: 0vw;
  width: 100%;
  letter-spacing: 2px;
  font-weight: 500;
  gap: 2vw;
}
.subBox .contentInner .profileInfo .profileImg {
  height: 15vw;
  width: 15vw;
  border-radius: 15px;
}
.subBox .contentInner .profileInfo .profileName {
  font-size: 16px;
  padding: 2vw;
  text-transform: uppercase;
  width: 100%;
}
.subBox .contentInner .profileInfo .profileName .profileNumber {
  font-size: 12px;
}
.subBox .contentInner .profileInfo .logIcon {
  height: 10vw;
  min-width: 10vw;
  fill: var(--ion-color-primary);
  stroke: var(--ion-color-primary);
}
.subBox .contentInner .itemText {
  display: flex;
  margin: 0 auto;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  border-radius: 15px;
  background: var(--ion-less-white);
  padding: 3vw;
}
.subBox .contentInner .itemText .lineItem {
  position: relative;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  transition: all 0.5s ease-in-out;
  margin: 0;
  padding: 0;
}
.subBox .contentInner .itemText .lineItem .title {
  letter-spacing: 1px;
  color: var(--ion-black-primary);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  transition: all 0.5s ease-in-out;
  padding: 1vw;
  overflow: auto;
  margin: 1vw;
  font-weight: 600;
  font-size: 14px;
}
.subBox .contentInner .itemText .lineItem .mealText {
  padding: 0;
  margin: 0vw;
  background: transparent;
  display: flex;
  border-radius: 7px;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 12px;
  letter-spacing: 1px;
  gap: 1vw;
}
.subBox .contentInner .itemText .lineItem .mealText .mealContainer {
  padding: 1vw;
  margin: 0vw;
  display: flex;
  border-radius: 7px;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  letter-spacing: 1px;
  min-width: 20vw;
  flex-direction: row;
}
.subBox .contentInner .itemText .lineItem .mealText .snackCat {
  background: var(--ion-more-tertiary);
  color: var(--ion-text-tertiary);
}
.subBox .contentInner .itemText .lineItem .mealText .mealCat {
  background: var(--ion-more-secondary);
  color: var(--ion-text-secondary);
}
.subBox .contentInner .itemText .progressDur {
  width: 100%;
  margin: 0 auto;
  height: 5vw;
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  position: relative;
  overflow: hidden;
  border-radius: 13px;
  border: 1px solid var(--ion-ultra-primary);
  background: var(--ion-white-primary);
}
.subBox .contentInner .itemText .progressDur .progress {
  background: linear-gradient(24deg, var(--ion-warm-primary) 0%, var(--ion-fade-primary) 50%, var(--ion-color-primary) 100%);
  background-size: 200% 200%;
  background-position: 0 100%;
  height: 3vw;
  border-radius: 13px;
  margin: 1vw;
  transition: width 1s ease-out;
  animation: pulse-width 8s infinite alternate ease-in-out;
}
.subBox .contentInner .itemText .typeTag {
  opacity: 1;
  padding: 1vw;
  margin: 0vw auto;
  background: none;
  position: relative;
  z-index: 2;
  border-radius: 0px;
  overflow: hidden;
  transition: all 0.5s ease-in-out;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
  background: transparent;
  margin-top: 2vw;
}
.subBox .contentInner .itemText .typeTag .subDates {
  color: var(--ion-black-primary);
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-direction: row;
  gap: 0vw;
  text-align: center;
  transition: all 0.5s ease-in-out;
  opacity: 1;
  line-height: 1;
  font-size: 11px;
  letter-spacing: 1px;
  width: 100%;
}
.subBox .contentInner .itemText .typeTag .subDates .progressTextI {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}
.subBox .contentInner .itemText .typeTag .subDates .progressTextI .progressText {
  color: var(--ion-dark-danger);
  font-size: 12px;
  margin: 0 0.5vw;
  font-weight: 500;
}
.subBox .contentInner .macroContainerInner {
  padding: 3vw;
  border-radius: 15px;
  margin: 0;
  gap: 3vw;
  display: flex;
  flex-direction: column;
  background: var(--ion-less-white);
}
.subBox .contentInner .macroContainerInner .macroSmallBar {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: flex-start;
  gap: 0vw;
  font-size: 14px;
}
.subBox .contentInner .macroContainerInner .macroSmallBar .calorieBigBar {
  width: 40vw;
  font-size: 16px;
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar {
  height: 7vw;
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  font-weight: 600;
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .macroAmt {
  display: flex;
  flex-direction: row;
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .metCont {
  border-radius: 15px;
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .metCont .metBar {
  height: 2vw;
  transition: all 0.6s ease-in-out;
  border-radius: 0 10px 10px 0;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 0vw;
  transform-origin: left;
  position: relative;
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .fullBar {
  border: 1px solid;
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .normalBar {
  border: 1px solid;
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .calorieBarCont {
  min-width: 40vw;
  border-color: var(--ion-color-calorie);
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .calorieBarCont .calorieBar {
  width: var(--width-calorie);
  background: linear-gradient(20deg, var(--ion-color-calorie) 0%, var(--ion-fade-calorie) 100%);
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .proteinBarCont {
  min-width: 26vw;
  border-color: var(--ion-color-prot);
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .proteinBarCont .proteinBar {
  width: var(--width-protein);
  background: linear-gradient(-40deg, var(--ion-color-prot) 0%, var(--ion-fade-prot) 100%);
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .fatBarCont {
  min-width: 26vw;
  border-color: var(--ion-color-fat);
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .fatBarCont .fatBar {
  width: var(--width-fat);
  background: linear-gradient(40deg, var(--ion-color-fat) 0%, var(--ion-fade-fat) 100%);
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .carbBarCont {
  min-width: 26vw;
  border-color: var(--ion-color-carb);
}
.subBox .contentInner .macroContainerInner .macroSmallBar .macroBar .carbBarCont .carbBar {
  width: var(--width-carb);
  background: linear-gradient(-20deg, var(--ion-color-carb) 0%, var(--ion-fade-carb) 100%);
}
.subBox .contentInner .btnBarBottom {
  display: flex;
  justify-content: flex-start;
  justify-items: center;
  align-items: center;
  flex-direction: row;
  position: relative;
  transform-origin: bottom;
  z-index: 2;
  margin: 0;
  border-radius: 20px;
  transition: all 0.5s ease-in-out;
  opacity: 1;
  pointer-events: auto;
  gap: 3vw;
  padding: 0;
  background: rgba(255, 255, 255, 0);
}
.subBox .contentInner .btnBarBottom .mainBtnBottom {
  height: 7vw;
  width: 28vw;
  margin: 0vw 0;
  position: relative;
  display: flex;
  align-items: center;
  gap: 2vw;
  padding: 1vw 2vw;
  border-radius: 8px;
  justify-content: center;
  z-index: 1;
  pointer-events: all;
  font-size: 12px;
  text-transform: capitalize;
  letter-spacing: 1px;
  backdrop-filter: blur(3px);
}
.subBox .contentInner .btnBarBottom .mainBtnBottom .smallIcon {
  width: 5vw;
  height: 5vw;
}
.subBox .contentInner .btnBarBottom .freezeSub {
  background: var(--ion-ultra-info);
  color: var(--ion-dark-info);
}
.subBox .contentInner .btnBarBottom .freezeSub .smallIcon {
  stroke: var(--ion-dark-info);
}
.subBox .contentInner .btnBarBottom .cancelSub {
  background: var(--ion-ultra-danger);
  color: var(--ion-dark-danger);
}
.subBox .contentInner .btnBarBottom .cancelSub .smallIcon {
  stroke: var(--ion-dark-danger);
}
.subBox .contentInner .btnBarBottom .upgradeSub {
  background: var(--ion-ultra-warning);
  color: var(--ion-dark-warning);
}
.subBox .contentInner .btnBarBottom .upgradeSub .smallIcon {
  stroke: var(--ion-dark-warning);
}
.subBox .contentInner .btnBarBottom .payNowSub {
  background: var(--ion-ultra-success);
  color: var(--ion-dark-success);
}
.subBox .contentInner .btnBarBottom .payNowSub .smallIcon {
  stroke: var(--ion-dark-success);
}
.subBox .contentInner .btnBarBottom .renewSub {
  background: var(--ion-ultra-tertiary);
  color: var(--ion-dark-tertiary);
}
.subBox .contentInner .btnBarBottom .renewSub .smallIcon {
  stroke: var(--ion-dark-tertiary);
}
.subBox .contentInner .btnBarBottom .hideSub {
  opacity: 0;
  background: var(--ion-color-tertiary);
  color: var(--ion-text-tertiary);
}
.subBox .contentInner .btnBarBottom .hideSub .smallIcon {
  stroke: var(--ion-text-tertiary);
}
.subBox .pendingContent .footerBlock {
  border: 1px solid var(--ion-fade-warning);
}
.subBox .pendingContent .footerBlock .progressDur {
  opacity: 0;
  height: 0;
}
.subBox .pendingContent .footerBlock .typeTag .mealType .price {
  border: 1px solid var(--ion-text-warning);
  color: var(--ion-text-warning);
  background-color: var(--ion-color-warning);
}
.subBox .pendingContent .footerBlock .typeTag .mealType .price .smallP {
  color: var(--ion-text-warning);
}

* {
  font-family: var(--ion-font-family);
}

@keyframes pulse-width {
  0% {
    transform: scaleX(0.98);
    transform-origin: left;
    background-position: 0% 100%;
  }
  100% {
    transform: scaleX(1.02);
    transform-origin: left;
    background-position: 100% 0%;
  }
}
.menu-list {
  background: transparent;
  --background: transparent;
  padding: 0;
  margin: 5vw auto;
  display: flex;
  flex-direction: column;
  z-index: 1;
  position: relative;
}
.menu-list .btnAccount {
  margin: 0vw auto;
  margin-bottom: 4vw !important;
  color: var(--ion-diffuseDark-primary);
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.5vw;
  border-radius: 100px;
  display: flex;
  z-index: 2;
  text-align: center;
  align-items: center;
  padding: 0 5%;
  overflow: hidden;
  justify-content: flex-end;
  text-transform: capitalize;
  position: relative;
  flex-direction: row-reverse;
  gap: 2vw;
  width: 84vw;
  height: 6vh;
  background: var(--ion-more-white);
  box-shadow: var(--shadow-l);
}
.menu-list .btnAccount ion-icon {
  height: 8vh;
  width: 10vh;
  fill: var(--ion-color-primary);
  color: var(--ion-color-primary);
  stroke: var(--ion-color-primary);
  z-index: 7;
  transform: rotate(15deg) scale(1);
  filter: blur(2px);
  opacity: 0.2;
  position: absolute;
  top: -2vh;
  right: 0vw;
  pointer-events: none;
}
.menu-list .btnAccount2 {
  margin: 0;
  margin-bottom: 1vw !important;
  letter-spacing: 0.5vw;
  max-width: 6vh;
  display: flex;
  z-index: 2;
  text-align: center;
  align-items: center;
  overflow: hidden;
  justify-content: flex-end;
  text-transform: capitalize;
  position: relative;
  flex-direction: row-reverse;
  max-height: 6vh;
  min-height: 6vh;
  min-width: 6vh;
  background: rgba(255, 255, 255, 0);
}
.menu-list .btnAccount2 ion-icon {
  height: 3vh;
  width: 3vh;
}

.whatsappIco {
  border: 1px solid rgba(83, 215, 83, 0.25);
  background: linear-gradient(90deg, rgba(83, 215, 83, 0.25) 0%, transparent 50%, rgba(83, 215, 83, 0.15) 100%);
}
.whatsappIco .icOnly {
  color: #37ca37 !important;
  opacity: 0.5 !important;
}

.instagramIco {
  border: 1px solid rgba(197, 144, 240, 0.25);
  background: linear-gradient(90deg, rgba(197, 144, 240, 0.25) 0%, transparent 50%, rgba(240, 144, 200, 0.15) 100%);
}
.instagramIco .icOnly {
  color: #a037ca !important;
  opacity: 0.5 !important;
}

.youtubeIco {
  border: 1px solid rgba(215, 83, 83, 0.25);
  background: linear-gradient(90deg, rgba(215, 83, 83, 0.25) 0%, transparent 50%, rgba(215, 83, 83, 0.15) 100%);
}
.youtubeIco .icOnly {
  color: #ff000f !important;
  opacity: 0.5 !important;
}

.iconac {
  height: 9vh;
  width: 25vh;
  fill: var(--ion-diffuseLight-secondary);
  stroke: none;
  top: 0vw;
  z-index: 1;
  position: absolute;
  transform: rotate(-15deg) scale(1.4);
  filter: blur(2px);
  opacity: 0.4;
  position: absolute;
  top: 0vw;
  right: -15vw;
  pointer-events: none;
}

.headingMacro {
  padding: 0vw;
  background: transparent;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-evenly;
  display: flex;
  gap: 2vw;
  border-radius: 0px;
  box-shadow: none;
  text-align: center;
  background: transparent;
  color: var(--ion-black-primary);
  height: 6vw;
}

.headingMacroIn {
  padding: 0vw;
  background: transparent;
  flex-direction: row;
  align-items: stretch;
  justify-content: space-evenly;
  display: flex;
  gap: 3vw;
  width: 100%;
  border-radius: 0px;
  box-shadow: none;
  text-align: center;
  background: transparent;
  color: var(--ion-black-primary);
  height: 6vw;
}

.addressActionNew {
  height: 6vw;
  width: 100%;
}
.addressActionNew ion-icon {
  height: 9vh;
  width: 9vh;
  fill: var(--ion-color-primary);
  stroke: var(--ion-color-primary);
  z-index: 7;
  transform: rotate(-15deg) scale(1);
  filter: blur(2px);
  opacity: 0.2;
  position: absolute;
  top: 0vw;
  right: 0vw;
  pointer-events: none;
}

.singleL {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  gap: 2vw;
}

.rewardsBar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  gap: 2vw;
  width: 92vw;
  margin: 3vw auto;
}

.headerBar {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 2vw;
  background: transparent;
}

.accountsSub {
  min-height: 30vw;
  overflow: hidden;
  border-radius: 20px;
  width: 100vw;
  margin: 0 auto;
  max-height: 70vw;
}

.headItem {
  position: sticky;
  top: 0;
  z-index: 3;
  display: flex;
  flex-direction: column;
}

.themeSelector {
  width: 30vw;
}

.titleMain {
  font-size: 18px;
  letter-spacing: 1px;
  text-transform: capitalize;
  font-weight: 400;
  margin: 5vw 10vw 0;
  display: flex;
  justify-content: flex-start;
}`, "",{"version":3,"sources":["webpack://./src/app/components/my-card/my-card.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,YAAA;EACA,uBAAA;EACA,UAAA;EACA,kBAAA;EACA,YAAA;EACA,kBAAA;EACA,cAAA;AACD;;AAGA;EACC,aAAA;EACA,sBAAA;EACA,2BAAA;EACA,UAAA;EACA,SAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,kBAAA;EACA,wCAAA;EACA,uBAAA;EACA,gCAAA;EAEA,gBAAA;EACA,sBAAA;EACA,QAAA;AADD;AAGC;EACC,YAAA;EAEE,yJAAA;EACI,0BAAA;EACJ,kCAAA;EACH,4CAAA;EACG,wCAAA;EAKF,aAAA;EACA,cAAA;EACA,kBAAA;EACA,uBAAA;EACA,gCAAA;EACA,sBAAA;EAEA,cAAA;EACA,WAAA;EAEA,mBAAA;EACA,QAAA;AARF;AAYE;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,2BAAA;EACA,gCAAA;EACA,SAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,gBAAA;EACA,QAAA;AAVH;AAYG;EACC,YAAA;EACA,WAAA;EACA,mBAAA;AAVJ;AAcG;EACC,eAAA;EACA,YAAA;EACA,yBAAA;EACA,WAAA;AAZJ;AAcI;EACC,eAAA;AAZL;AAgBG;EACC,YAAA;EACA,eAAA;EACA,8BAAA;EACA,gCAAA;AAdJ;AAkBE;EACC,aAAA;EAEA,cAAA;EACA,sBAAA;EACA,uBAAA;EACA,uBAAA;EACA,mBAAA;EACC,iCAAA;EAED,YAAA;AAlBH;AAoBG;EACC,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,gCAAA;EACA,SAAA;EACA,UAAA;AAlBJ;AAsBI;EAEC,mBAAA;EACA,+BAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,gCAAA;EACA,YAAA;EACA,cAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;AArBL;AA4BI;EACC,UAAA;EACA,WAAA;EACA,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,sBAAA;EACA,mBAAA;EAEA,eAAA;EACA,mBAAA;EACA,QAAA;AA3BL;AAgCK;EACC,YAAA;EACA,WAAA;EAEA,aAAA;EACA,kBAAA;EACA,uBAAA;EACA,mBAAA;EAEA,eAAA;EACA,mBAAA;EACA,eAAA;EACA,mBAAA;AAhCN;AAmCK;EACC,oCAAA;EACA,+BAAA;AAjCN;AAoCK;EACC,qCAAA;EACA,gCAAA;AAlCN;AAuCG;EACC,WAAA;EACA,cAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,0CAAA;EACA,oCAAA;AArCJ;AAuCI;EAEC,0HAAA;EACA,0BAAA;EACA,2BAAA;EACA,WAAA;EACA,mBAAA;EACA,WAAA;EACA,6BAAA;EACA,wDAAA;AAtCL;AA2CG;EACC,UAAA;EACA,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,sBAAA;EAGA,uBAAA;EACA,eAAA;AA3CJ;AA+CI;EAEC,+BAAA;EACA,aAAA;EACA,mBAAA;EACA,6BAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,gCAAA;EACA,UAAA;EACA,cAAA;EACA,eAAA;EACA,mBAAA;EACA,WAAA;AA9CL;AAgDK;EACC,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AA9CN;AAgDM;EACC,6BAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AA9CP;AAuDE;EACC,YAAA;EACA,mBAAA;EACA,SAAA;EACA,QAAA;EACA,aAAA;EACA,sBAAA;EACC,iCAAA;AArDJ;AAwDG;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,uBAAA;EACA,QAAA;EACA,eAAA;AAtDJ;AAwDI;EACC,WAAA;EACA,eAAA;AAtDL;AAyDI;EACC,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,sBAAA;EACA,gBAAA;AAvDL;AAyDK;EACC,aAAA;EACA,mBAAA;AAvDN;AA2DK;EAGC,mBAAA;AA3DN;AA6DM;EACC,WAAA;EACA,gCAAA;EACA,4BAAA;EACA,aAAA;EACA,mBAAA;EACA,2BAAA;EACA,YAAA;EACA,sBAAA;EACA,kBAAA;AA3DP;AAiEK;EACC,iBAAA;AA/DN;AAkEK;EACC,iBAAA;AAhEN;AAoEK;EACC,eAAA;EACA,sCAAA;AAlEN;AAoEM;EACC,2BAAA;EACA,6FAAA;AAlEP;AAsEK;EACC,eAAA;EACA,mCAAA;AApEN;AAsEM;EACC,2BAAA;EACA,wFAAA;AApEP;AAwEK;EACC,eAAA;EACA,kCAAA;AAtEN;AAwEM;EACC,uBAAA;EACA,qFAAA;AAtEP;AA0EK;EACC,eAAA;EACA,mCAAA;AAxEN;AA0EM;EACC,wBAAA;EACA,wFAAA;AAxEP;AAgFE;EACC,aAAA;EACA,2BAAA;EACA,qBAAA;EACA,mBAAA;EACA,mBAAA;EACA,kBAAA;EACA,wBAAA;EACA,UAAA;EAEA,SAAA;EACA,mBAAA;EACA,gCAAA;EACA,UAAA;EACA,oBAAA;EACA,QAAA;EACA,UAAA;EACA,kCAAA;AA/EH;AA0GG;EAEC,WAAA;EACA,WAAA;EACA,aAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,kBAAA;EACA,uBAAA;EACA,UAAA;EAEA,mBAAA;EACA,eAAA;EACA,0BAAA;EACA,mBAAA;EACA,0BAAA;AA1GJ;AA4GI;EACC,UAAA;EACA,WAAA;AA1GL;AAgHG;EAEC,iCAAA;EACA,2BAAA;AA/GJ;AAiHI;EACC,4BAAA;AA/GL;AAmHG;EACC,mCAAA;EACA,6BAAA;AAjHJ;AAmHI;EACC,8BAAA;AAjHL;AAqHG;EACC,oCAAA;EACA,8BAAA;AAnHJ;AAqHI;EACC,+BAAA;AAnHL;AAuHG;EACC,oCAAA;EACA,8BAAA;AArHJ;AAuHI;EACC,+BAAA;AArHL;AAyHG;EACC,qCAAA;EACA,+BAAA;AAvHJ;AAyHI;EACC,gCAAA;AAvHL;AA2HG;EACC,UAAA;EACA,qCAAA;EACA,+BAAA;AAzHJ;AA2HI;EACC,gCAAA;AAzHL;AAyIE;EACC,yCAAA;AAvIH;AAyIG;EACC,UAAA;EACA,SAAA;AAvIJ;AA4IK;EACC,yCAAA;EACA,8BAAA;EACA,0CAAA;AA1IN;AA4IM;EACC,8BAAA;AA1IP;;AAsJA;EACC,mCAAA;AAnJD;;AAsJA;EACC;IAGC,uBAAA;IACA,sBAAA;IACA,4BAAA;EArJA;EAwJD;IAEC,uBAAA;IACA,sBAAA;IACA,4BAAA;EAvJA;AACF;AA4JC;EACC,uBAAA;EACA,yBAAA;EACA,UAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,UAAA;EACA,kBAAA;AA1JF;AA8JE;EACK,gBAAA;EACH,6BAAA;EACA,qCAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;EAEA,UAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EACA,QAAA;EACA,WAAA;EACA,WAAA;EACA,iCAAA;EACA,2BAAA;AA7JJ;AA+JG;EACE,WAAA;EACD,WAAA;EACA,8BAAA;EACA,+BAAA;EACA,gCAAA;EACA,UAAA;EACA,iCAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,SAAA;EACA,UAAA;EACA,oBAAA;AA7JJ;AAiKG;EACA,SAAA;EACA,6BAAA;EAIA,qBAAA;EACA,cAAA;EAEA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,mBAAA;EAEA,gBAAA;EACA,yBAAA;EACA,0BAAA;EACA,kBAAA;EACA,2BAAA;EAGA,eAAA;EACA,eAAA;EACA,cAAA;EACA,kCAAA;AAtKH;AAwKG;EACC,WAAA;EACA,UAAA;AAtKJ;;AAwLC;EACC,yCAAA;EACA,6GAAA;AArLF;AAwLE;EAGC,yBAAA;EACA,uBAAA;AAxLH;;AA6LC;EAEC,2CAAA;EACA,iHAAA;AA3LF;AA8LE;EAIC,yBAAA;EACA,uBAAA;AA/LH;;AAoMC;EAEC,yCAAA;EACA,6GAAA;AAlMF;AAoME;EAGC,yBAAA;EACA,uBAAA;AApMH;;AA2MA;EACC,WAAA;EACA,WAAA;EACA,uCAAA;EACA,YAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,oCAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,oBAAA;AAxMD;;AA8MA;EAEC,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,aAAA;EACA,QAAA;EAGA,kBAAA;EACA,gBAAA;EAEA,kBAAA;EAEA,uBAAA;EACA,+BAAA;EACA,WAAA;AAhND;;AAmNA;EAEC,YAAA;EACA,uBAAA;EACA,mBAAA;EACA,oBAAA;EACA,6BAAA;EACA,aAAA;EACA,QAAA;EACI,WAAA;EAGJ,kBAAA;EACA,gBAAA;EAEA,kBAAA;EAEA,uBAAA;EACA,+BAAA;EACA,WAAA;AArND;;AAwNA;EACC,WAAA;EACA,WAAA;AArND;AAuNC;EACC,WAAA;EACA,UAAA;EACA,8BAAA;EACA,gCAAA;EACA,UAAA;EACA,kCAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,QAAA;EACA,UAAA;EACA,oBAAA;AArNF;;AA2NA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,yBAAA;EACA,QAAA;AAxND;;AA2NA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,uBAAA;EACA,QAAA;EACA,WAAA;EACA,gBAAA;AAxND;;AA2NA;EACC,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,8BAAA;EACA,QAAA;EACA,uBAAA;AAxND;;AA2NA;EACC,gBAAA;EACA,gBAAA;EACA,mBAAA;EACA,YAAA;EACA,cAAA;EACA,gBAAA;AAxND;;AA2NA;EAKC,gBAAA;EACA,MAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;AA5ND;;AA+NA;EACC,WAAA;AA5ND;;AA+NA;EACI,eAAA;EACA,mBAAA;EACA,0BAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EAEA,2BAAA;AA7NJ","sourcesContent":[":host {\n\tdisplay: flex;\n\theight: 100%;\n\tbackground: transparent;\n\tz-index: 1;\n\tposition: relative;\n\twidth: 100vw;\n\tposition: relative;\n\tmargin: 0 auto;\n\n}\n\n.subBox {\n\tdisplay: flex;\n\tflex-direction: column;\n\tjustify-content: flex-start;\n\tpadding: 0;\n\tmargin: 0;\n\toverflow: visible;\n\tmin-width: 100%;\n\tmax-width: 100%;\n\tborder-radius: 0px;\n\tbackground-color: rgba(255, 255, 255, 0);\n\tbox-sizing: content-box;\n\ttransition: all 0.5s ease-in-out;\n\t// height: 100vw;\n\tbox-shadow: none;\n\tflex-direction: column;\n\tgap: 5vw;\n\n\t.contentInner {\n\t\tpadding: 3vw;\n\t\t// box-shadow: var(--shadow-m);\n    background: linear-gradient(40deg, hsl(var(--drop-color-primary)/0.2) 0%, hsl(var(--drop-dark-primary)/0.3) 50%, hsl(var(--drop-color-primary)/0.2) 100%);\n        backdrop-filter: blur(3px);\n    -webkit-backdrop-filter: blur(3px);\n\tborder: 1px solid var(--ion-light-secondary);\n    background-color: #fff0;\n\n\t\t// background: linear-gradient(70deg, var(--ion-shadeDark-secondary) 0%, var(--ion-color-secondary) 50%, var(--ion-shadeLight-secondary) 100%);\n\t\t// background-size: 200% 200%;\n\t\t// background-position: 0 100%;\n\t\tdisplay: flex;\n\t\toverflow: auto;\n\t\tposition: relative;\n\t\tjustify-content: center;\n\t\ttransition: all 0.5s ease-in-out;\n\t\tflex-direction: column;\n\t\t// width: 100%;\n\t\tmargin: 0 auto;\n\t\twidth: 92vw;\n\t\t// height: 100vw;\n\t\tborder-radius: 20px;\n\t\tgap: 3vw;\n\t\t// box-shadow: var(--shadow-m);\n\n\n\t\t.profileInfo {\n\t\t\tposition: relative;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: row;\n\t\t\talign-items: center;\n\t\t\tjustify-content: flex-start;\n\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\tmargin: 0;\n\t\t\tpadding: 0vw;\n\t\t\twidth: 100%;\n\t\t\tletter-spacing: 2px;\n\t\t\tfont-weight: 500;\n\t\t\tgap: 2vw;\n\n\t\t\t.profileImg {\n\t\t\t\theight: 15vw;\n\t\t\t\twidth: 15vw;\n\t\t\t\tborder-radius: 15px;\n\n\t\t\t}\n\n\t\t\t.profileName {\n\t\t\t\tfont-size: 16px;\n\t\t\t\tpadding: 2vw;\n\t\t\t\ttext-transform: uppercase;\n\t\t\t\twidth: 100%;\n\n\t\t\t\t.profileNumber {\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.logIcon {\n\t\t\t\theight: 10vw;\n\t\t\t\tmin-width: 10vw;\n\t\t\t\tfill: var(--ion-color-primary);\n\t\t\t\tstroke: var(--ion-color-primary);\n\t\t\t}\n\t\t}\n\n\t\t.itemText {\n\t\t\tdisplay: flex;\n\t\t\t// width: 92vw;\n\t\t\tmargin: 0 auto;\n\t\t\tflex-direction: column;\n\t\t\talign-items: flex-start;\n\t\t\tjustify-content: center;\n\t\t\tborder-radius: 15px;\n    background: var(--ion-less-white);\n    // box-shadow: var(--shadow-l);\n\t\t\tpadding: 3vw;\n\n\t\t\t.lineItem {\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: center;\n\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\tmargin: 0;\n\t\t\t\tpadding: 0;\n\t\t\t\t// width: 100%;\n\t\t\t\t// height: 20vw;\n\n\t\t\t\t.title {\n\t\t\t\t\t// white-space: normal;\n\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\tcolor: var(--ion-black-primary);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\t\tpadding: 1vw;\n\t\t\t\t\toverflow: auto;\n\t\t\t\t\tmargin: 1vw;\n\t\t\t\t\tfont-weight: 600;\n\t\t\t\t\tfont-size: 14px;\n\n\t\t\t\t}\n\n\n\n\n\t\t\t\t.mealText {\n\t\t\t\t\tpadding: 0;\n\t\t\t\t\tmargin: 0vw;\n\t\t\t\t\tbackground: transparent;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\tborder-radius: 7px;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\t// height: 6vw;\n\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\tgap: 1vw;\n\t\t\t\t\t// min-width: 46vw;\n\t\t\t\t\t// max-width: 46vw;\n\t\t\t\t\t// padding: 0 1vw;\n\n\t\t\t\t\t.mealContainer {\n\t\t\t\t\t\tpadding: 1vw;\n\t\t\t\t\t\tmargin: 0vw;\n\t\t\t\t\t\t// background: var(--ion-ultra-secondary);\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tborder-radius: 7px;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t// height: 6vw;\n\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\t\tmin-width: 20vw;\n\t\t\t\t\t\tflex-direction: row;\n\t\t\t\t\t}\n\n\t\t\t\t\t.snackCat {\n\t\t\t\t\t\tbackground: var(--ion-more-tertiary);\n\t\t\t\t\t\tcolor: var(--ion-text-tertiary);\n\t\t\t\t\t}\n\n\t\t\t\t\t.mealCat {\n\t\t\t\t\t\tbackground: var(--ion-more-secondary);\n\t\t\t\t\t\tcolor: var(--ion-text-secondary);\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.progressDur {\n\t\t\t\twidth: 100%;\n\t\t\t\tmargin: 0 auto;\n\t\t\t\theight: 5vw;\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\tjustify-content: flex-start;\n\t\t\t\talign-items: center;\n\t\t\t\tposition: relative;\n\t\t\t\toverflow: hidden;\n\t\t\t\tborder-radius: 13px;\n\t\t\t\tborder: 1px solid var(--ion-ultra-primary);\n\t\t\t\tbackground: var(--ion-white-primary);\n\n\t\t\t\t.progress {\n\t\t\t\t\t// background: var(--ion-half-primary);\n\t\t\t\t\tbackground: linear-gradient(24deg, var(--ion-warm-primary) 0%, var(--ion-fade-primary) 50%, var(--ion-color-primary) 100%);\n\t\t\t\t\tbackground-size: 200% 200%;\n\t\t\t\t\tbackground-position: 0 100%;\n\t\t\t\t\theight: 3vw;\n\t\t\t\t\tborder-radius: 13px;\n\t\t\t\t\tmargin: 1vw;\n\t\t\t\t\ttransition: width 1s ease-out; // Smooth transition for width changes\n\t\t\t\t\tanimation: pulse-width 8s infinite alternate ease-in-out;\n\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.typeTag {\n\t\t\t\topacity: 1;\n\t\t\t\tpadding: 1vw;\n\t\t\t\tmargin: 0vw auto;\n\t\t\t\tbackground: none;\n\t\t\t\tposition: relative;\n\t\t\t\tz-index: 2;\n\t\t\t\tborder-radius: 0px;\n\t\t\t\toverflow: hidden;\n\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\tflex-direction: column;\n\t\t\t\t// width: 100%;\n\t\t\t\t// height: 15vw;\n\t\t\t\tbackground: transparent;\n\t\t\t\tmargin-top: 2vw;\n\n\n\n\t\t\t\t.subDates {\n\t\t\t\t\t// white-space: normal;\n\t\t\t\t\tcolor: var(--ion-black-primary);\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: center;\n\t\t\t\t\tjustify-content: space-around;\n\t\t\t\t\tflex-direction: row;\n\t\t\t\t\tgap: 0vw;\n\t\t\t\t\ttext-align: center;\n\t\t\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\t\t\topacity: 1;\n\t\t\t\t\tline-height: 1;\n\t\t\t\t\tfont-size: 11px;\n\t\t\t\t\tletter-spacing: 1px;\n\t\t\t\t\twidth: 100%;\n\n\t\t\t\t\t.progressTextI {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\tjustify-content: center;\n\t\t\t\t\t\tflex-direction: row;\n\n\t\t\t\t\t\t.progressText {\n\t\t\t\t\t\t\tcolor: var(--ion-dark-danger);\n\t\t\t\t\t\t\tfont-size: 12px;\n\t\t\t\t\t\t\tmargin: 0 0.5vw;\n\t\t\t\t\t\t\tfont-weight: 500;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\n\t\t\t}\n\t\t}\n\n\n\t\t.macroContainerInner {\n\t\t\tpadding: 3vw;\n\t\t\tborder-radius: 15px;\n\t\t\tmargin: 0;\n\t\t\tgap: 3vw;\n\t\t\tdisplay: flex;\n\t\t\tflex-direction: column;\n    background: var(--ion-less-white);\n    // box-shadow: var(--shadow-l);\n\n\t\t\t.macroSmallBar {\n\t\t\t\tdisplay: flex;\n\t\t\t\tflex-direction: row;\n\t\t\t\tjustify-content: space-between;\n\t\t\t\talign-items: flex-start;\n\t\t\t\tgap: 0vw;\n\t\t\t\tfont-size: 14px;\n\n\t\t\t\t.calorieBigBar {\n\t\t\t\t\twidth: 40vw;\n\t\t\t\t\tfont-size: 16px;\n\t\t\t\t}\n\n\t\t\t\t.macroBar {\n\t\t\t\t\theight: 7vw;\n\t\t\t\t\tposition: relative;\n\t\t\t\t\tdisplay: flex;\n\t\t\t\t\talign-items: flex-start;\n\t\t\t\t\tjustify-content: center;\n\t\t\t\t\tflex-direction: column;\n\t\t\t\t\tfont-weight: 600;\n\n\t\t\t\t\t.macroAmt {\n\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\tflex-direction: row;\n\t\t\t\t\t\t// height: 6vw;\n\t\t\t\t\t}\n\n\t\t\t\t\t.metCont {\n\t\t\t\t\t\t// width: 30vw;\n\n\t\t\t\t\t\tborder-radius: 15px;\n\n\t\t\t\t\t\t.metBar {\n\t\t\t\t\t\t\theight: 2vw;\n\t\t\t\t\t\t\ttransition: all 0.6s ease-in-out;\n\t\t\t\t\t\t\tborder-radius: 0 10px 10px 0;\n\t\t\t\t\t\t\tdisplay: flex;\n\t\t\t\t\t\t\talign-items: center;\n\t\t\t\t\t\t\tjustify-content: flex-start;\n\t\t\t\t\t\t\tpadding: 0vw;\n\t\t\t\t\t\t\ttransform-origin: left;\n\t\t\t\t\t\t\tposition: relative;\n\t\t\t\t\t\t\t// left: 0;\n\t\t\t\t\t\t\t// bottom: 0;\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.fullBar {\n\t\t\t\t\t\tborder: 1px solid;\n\t\t\t\t\t}\n\n\t\t\t\t\t.normalBar {\n\t\t\t\t\t\tborder: 1px solid;\n\n\t\t\t\t\t}\n\n\t\t\t\t\t.calorieBarCont {\n\t\t\t\t\t\tmin-width: 40vw;\n\t\t\t\t\t\tborder-color: var(--ion-color-calorie);\n\n\t\t\t\t\t\t.calorieBar {\n\t\t\t\t\t\t\twidth: var(--width-calorie);\n\t\t\t\t\t\t\tbackground: linear-gradient(20deg, var(--ion-color-calorie) 0%, var(--ion-fade-calorie) 100%);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.proteinBarCont {\n\t\t\t\t\t\tmin-width: 26vw;\n\t\t\t\t\t\tborder-color: var(--ion-color-prot);\n\n\t\t\t\t\t\t.proteinBar {\n\t\t\t\t\t\t\twidth: var(--width-protein);\n\t\t\t\t\t\t\tbackground: linear-gradient(-40deg, var(--ion-color-prot) 0%, var(--ion-fade-prot) 100%);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.fatBarCont {\n\t\t\t\t\t\tmin-width: 26vw;\n\t\t\t\t\t\tborder-color: var(--ion-color-fat);\n\n\t\t\t\t\t\t.fatBar {\n\t\t\t\t\t\t\twidth: var(--width-fat);\n\t\t\t\t\t\t\tbackground: linear-gradient(40deg, var(--ion-color-fat) 0%, var(--ion-fade-fat) 100%);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\n\t\t\t\t\t.carbBarCont {\n\t\t\t\t\t\tmin-width: 26vw;\n\t\t\t\t\t\tborder-color: var(--ion-color-carb);\n\n\t\t\t\t\t\t.carbBar {\n\t\t\t\t\t\t\twidth: var(--width-carb);\n\t\t\t\t\t\t\tbackground: linear-gradient(-20deg, var(--ion-color-carb) 0%, var(--ion-fade-carb) 100%);\n\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\n\t\t.btnBarBottom {\n\t\t\tdisplay: flex;\n\t\t\tjustify-content: flex-start;\n\t\t\tjustify-items: center;\n\t\t\talign-items: center;\n\t\t\tflex-direction: row;\n\t\t\tposition: relative;\n\t\t\ttransform-origin: bottom;\n\t\t\tz-index: 2;\n\t\t\t// background: transparent;\n\t\t\tmargin: 0;\n\t\t\tborder-radius: 20px;\n\t\t\ttransition: all 0.5s ease-in-out;\n\t\t\topacity: 1;\n\t\t\tpointer-events: auto;\n\t\t\tgap: 3vw;\n\t\t\tpadding: 0;\n\t\t\tbackground: #fff0;\n    // background: var(--ion-ultra-white);\n    // box-shadow: var(--shadow-l);\n\n\n\n\t\t\t// .btnBarBottomInner {\n\t\t\t// \tdisplay: flex;\n\t\t\t// \tbackground: var(--ion-white-primary);\n\t\t\t// \tjustify-content: space-between;\n\t\t\t// \tjustify-items: center;\n\t\t\t// \talign-items: flex-end;\n\t\t\t// \tflex-direction: row;\n\t\t\t// \tposition: relative;\n\t\t\t// \ttransform-origin: bottom;\n\t\t\t// \tz-index: 2;\n\t\t\t// \t// background: transparent;\n\t\t\t// \tmargin: 0;\n\t\t\t// \tborder-radius: 15px;\n\t\t\t// \t// height: 10vw;\n\t\t\t// \twidth: 92vw;\n\t\t\t// \ttransition: all 0.5s ease-in-out;\n\t\t\t// \topacity: 1;\n\t\t\t// \tpointer-events: auto;\n\t\t\t// \tgap: 2vw;\n\t\t\t// \tpadding: 2vw;\n\n\t\t\t.mainBtnBottom {\n\t\t\t\t// for substraction\n\t\t\t\theight: 7vw;\n\t\t\t\twidth: 28vw;\n\t\t\t\tmargin: 0vw 0;\n\t\t\t\tposition: relative;\n\t\t\t\tdisplay: flex;\n\t\t\t\talign-items: center;\n\t\t\t\tgap: 2vw;\n\t\t\t\tpadding: 1vw 2vw;\n\t\t\t\tborder-radius: 8px;\n\t\t\t\tjustify-content: center;\n\t\t\t\tz-index: 1;\n\t\t\t\t// box-shadow: var(--shadow-l);\n\t\t\t\tpointer-events: all;\n\t\t\t\tfont-size: 12px;\n\t\t\t\ttext-transform: capitalize;\n\t\t\t\tletter-spacing: 1px;\n\t\t\t\tbackdrop-filter: blur(3px);\n\n\t\t\t\t.smallIcon {\n\t\t\t\t\twidth: 5vw;\n\t\t\t\t\theight: 5vw;\n\t\t\t\t}\n\n\n\t\t\t}\n\n\t\t\t.freezeSub {\n\t\t\t\t// background: var(--ion-text-info);\n\t\t\t\tbackground: var(--ion-ultra-info);\n\t\t\t\tcolor: var(--ion-dark-info);\n\n\t\t\t\t.smallIcon {\n\t\t\t\t\tstroke: var(--ion-dark-info);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.cancelSub {\n\t\t\t\tbackground: var(--ion-ultra-danger);\n\t\t\t\tcolor: var(--ion-dark-danger);\n\n\t\t\t\t.smallIcon {\n\t\t\t\t\tstroke: var(--ion-dark-danger);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.upgradeSub {\n\t\t\t\tbackground: var(--ion-ultra-warning);\n\t\t\t\tcolor: var(--ion-dark-warning);\n\n\t\t\t\t.smallIcon {\n\t\t\t\t\tstroke: var(--ion-dark-warning);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.payNowSub {\n\t\t\t\tbackground: var(--ion-ultra-success);\n\t\t\t\tcolor: var(--ion-dark-success);\n\n\t\t\t\t.smallIcon {\n\t\t\t\t\tstroke: var(--ion-dark-success);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.renewSub {\n\t\t\t\tbackground: var(--ion-ultra-tertiary);\n\t\t\t\tcolor: var(--ion-dark-tertiary);\n\n\t\t\t\t.smallIcon {\n\t\t\t\t\tstroke: var(--ion-dark-tertiary);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t.hideSub {\n\t\t\t\topacity: 0;\n\t\t\t\tbackground: var(--ion-color-tertiary);\n\t\t\t\tcolor: var(--ion-text-tertiary);\n\n\t\t\t\t.smallIcon {\n\t\t\t\t\tstroke: var(--ion-text-tertiary);\n\t\t\t\t}\n\t\t\t}\n\n\t\t\t// }\n\t\t}\n\n\t}\n\n\t.activeContent {\n\t\t\n\t}\n\n\t.pendingContent {\n\t\t// background: linear-gradient(0deg, var(--ion-bareLight-warning) 0%, var(--ion-washed-warning) 50%, var(--ion-pass-warning) 100%);\n\n\t\t.footerBlock {\n\t\t\tborder: 1px solid var(--ion-fade-warning);\n\n\t\t\t.progressDur {\n\t\t\t\topacity: 0;\n\t\t\t\theight: 0;\n\t\t\t}\n\n\t\t\t.typeTag {\n\t\t\t\t.mealType {\n\t\t\t\t\t.price {\n\t\t\t\t\t\tborder: 1px solid var(--ion-text-warning);\n\t\t\t\t\t\tcolor: var(--ion-text-warning);\n\t\t\t\t\t\tbackground-color: var(--ion-color-warning);\n\n\t\t\t\t\t\t.smallP {\n\t\t\t\t\t\t\tcolor: var(--ion-text-warning);\n\t\t\t\t\t\t}\n\t\t\t\t\t}\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n\n\n\n\n* {\n\tfont-family: var(--ion-font-family);\n}\n\n@keyframes pulse-width {\n\t0% {\n\t\t// This calculates 5% less than the actual target width\n\t\t// The min(100vw, ...) is a safeguard for extreme values, though not strictly needed for percentage\n\t\ttransform: scaleX(0.98); // Scale down to 95% of its set width\n\t\ttransform-origin: left; // Scale from the left edge\n\t\tbackground-position: 0% 100%;\n\t}\n\n\t100% {\n\t\t// This calculates 5% more than the actual target width\n\t\ttransform: scaleX(1.02); // Scale up to 105% of its set width\n\t\ttransform-origin: left; // Scale from the left edge\n\t\tbackground-position: 100% 0%;\n\t}\n}\n\n\n\n\t.menu-list {\n\t\tbackground: transparent;\n\t\t--background: transparent;\n\t\tpadding: 0;\n\t\tmargin: 5vw auto;\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tz-index: 1;\n\t\tposition: relative;\n\t\t// min-height: 150vh;\n\n\n\t\t.btnAccount {\n\t\t\t    margin: 0vw auto;\n    margin-bottom: 4vw !important;\n    color: var(--ion-diffuseDark-primary);\n    font-size: 12px;\n    font-weight: 500;\n    letter-spacing: 0.5vw;\n    border-radius: 100px;\n    display: flex\n;\n    z-index: 2;\n    text-align: center;\n    align-items: center;\n    padding: 0 5%;\n    overflow: hidden;\n    justify-content: flex-end;\n    text-transform: capitalize;\n    position: relative;\n    flex-direction: row-reverse;\n    gap: 2vw;\n    width: 84vw;\n    height: 6vh;\n    background: var(--ion-more-white);\n    box-shadow: var(--shadow-l);\n\n\t\t\tion-icon {\n\t    height: 8vh;\n    width: 10vh;\n    fill: var(--ion-color-primary);\n    color: var(--ion-color-primary);\n    stroke: var(--ion-color-primary);\n    z-index: 7;\n    transform: rotate(15deg) scale(1);\n    filter: blur(2px);\n    opacity: 0.2;\n    position: absolute;\n    top: -2vh;\n    right: 0vw;\n    pointer-events: none;\n\n\t\t\t}\n\t\t}\n\t\t\t.btnAccount2 {\n\t\t\tmargin: 0;\n\t\t\tmargin-bottom: 1vw !important;\n\t\t\t// color: var(--ion-diffuseDark-primary);\n\t\t\t// font-size: 12px;\n\t\t\t// font-weight: 500;\n\t\t\tletter-spacing: 0.5vw;\n\t\t\tmax-width: 6vh;\n\t\t\t// border-radius: 10px;\n\t\t\tdisplay: flex;\n\t\t\tz-index: 2;\n\t\t\ttext-align: center;\n\t\t\talign-items: center;\n\t\t\t// padding: 0 5%;\n\t\t\toverflow: hidden;\n\t\t\tjustify-content: flex-end;\n\t\t\ttext-transform: capitalize;\n\t\t\tposition: relative;\n\t\t\tflex-direction: row-reverse;\n\t\t\t// gap: 2vw;\n\t\t\t// width: 92vw;\n\t\t\tmax-height: 6vh;\n\t\t\tmin-height: 6vh;\n\t\t\tmin-width: 6vh;\n\t\t\tbackground: #fff0;\n\n\t\t\tion-icon {\n\t\t\t\theight: 3vh;\n\t\t\t\twidth: 3vh;\n\t\t\t\t// width: 12vh;\n\t\t\t\t// fill: var(--ion-color-primary);\n\t\t\t\t// color: var(--ion-color-primary);\n\t\t\t\t// stroke: var(--ion-color-primary);\n\t\t\t\t// z-index: 7;\n\t\t\t\t// transform: rotate(-15deg) scale(1);\n\t\t\t\t// filter: blur(2px);\n\t\t\t\t// opacity: 0.2;\n\t\t\t\t// position: absolute;\n\t\t\t\t// top: 0vw;\n\t\t\t\t// right: 0vw;\n\t\t\t\t// pointer-events: none;\n\n\t\t\t}\n\t\t}\n\t}\n\n\t.whatsappIco {\n\t\tborder: 1px solid rgba(83, 215, 83, 0.25);\n\t\tbackground: linear-gradient(90deg, rgba(83, 215, 83, 0.25) 0%, transparent 50%, rgba(83, 215, 83, 0.15) 100%);\n\n\t\t// border-radius: 15px 5px 15px 15px;\n\t\t.icOnly {\n\t\t\t// transform: rotate(15deg) scale(1.15) !important;\n\t\t\t// filter: none !important;\n\t\t\tcolor: #37ca37 !important;\n\t\t\topacity: 0.5 !important;\n\t\t\t// right: 0;\n\t\t}\n\t}\n\n\t.instagramIco {\n\n\t\tborder: 1px solid rgba(197, 144, 240, 0.25);\n\t\tbackground: linear-gradient(90deg, rgba(197, 144, 240, 0.25) 0%, transparent 50%, rgba(240, 144, 200, 0.15) 100%);\n\n\t\t// border-radius: 15px 15px 5px 15px;\n\t\t.icOnly {\n\n\t\t\t// transform: rotate(35deg) scale(1.15) !important;\n\t\t\t// filter: none !important;\n\t\t\tcolor: #a037ca !important;\n\t\t\topacity: 0.5 !important;\n\t\t\t// left: 0;\n\t\t}\n\t}\n\n\t.youtubeIco {\n\n\t\tborder: 1px solid rgba(215, 83, 83, 0.25);\n\t\tbackground: linear-gradient(90deg, rgba(215, 83, 83, 0.25) 0%, transparent 50%, rgba(215, 83, 83, 0.15) 100%);\n\n\t\t.icOnly {\n\t\t\t// transform: rotate(-45deg) scale(1.15) !important;\n\t\t\t// filter: none !important;\n\t\t\tcolor: #ff000f !important;\n\t\t\topacity: 0.5 !important;\n\t\t\t// right: 0;\n\t\t}\n\t}\n\n \n\n.iconac {\n\theight: 9vh;\n\twidth: 25vh;\n\tfill: var(--ion-diffuseLight-secondary);\n\tstroke: none;\n\ttop: 0vw;\n\tz-index: 1;\n\tposition: absolute;\n\ttransform: rotate(-15deg) scale(1.4);\n\tfilter: blur(2px);\n\topacity: 0.4;\n\tposition: absolute;\n\ttop: 0vw;\n\tright: -15vw;\n\tpointer-events: none;\n\n\n}\n\n\n.headingMacro {\n\t// margin: 2vw auto;\n\tpadding: 0vw;\n\tbackground: transparent;\n\tflex-direction: row;\n\talign-items: stretch;\n\tjustify-content: space-evenly;\n\tdisplay: flex;\n\tgap: 2vw;\n\t// border-top: 1px dashed var(--ion-fade-tertiary);\n\t// border-bottom: 1px dashed var(--ion-fade-tertiary);\n\tborder-radius: 0px;\n\tbox-shadow: none;\n\t// width: 92vw;\n\ttext-align: center;\n\t// text-decoration: underline;\n\tbackground: transparent;\n\tcolor: var(--ion-black-primary);\n\theight: 6vw;\n}\n\n.headingMacroIn {\n\t// margin: 2vw auto;\n\tpadding: 0vw;\n\tbackground: transparent;\n\tflex-direction: row;\n\talign-items: stretch;\n\tjustify-content: space-evenly;\n\tdisplay: flex;\n\tgap: 3vw;\n\t    width: 100%;\n\t// border-top: 1px dashed var(--ion-fade-tertiary);\n\t// border-bottom: 1px dashed var(--ion-fade-tertiary);\n\tborder-radius: 0px;\n\tbox-shadow: none;\n\t// width: 92vw;\n\ttext-align: center;\n\t// text-decoration: underline;\n\tbackground: transparent;\n\tcolor: var(--ion-black-primary);\n\theight: 6vw;\n}\n\n.addressActionNew {\n\theight: 6vw;\n\twidth: 100%;\n\n\tion-icon {\n\t\theight: 9vh;\n\t\twidth: 9vh;\n\t\tfill: var(--ion-color-primary);\n\t\tstroke: var(--ion-color-primary);\n\t\tz-index: 7;\n\t\ttransform: rotate(-15deg) scale(1);\n\t\tfilter: blur(2px);\n\t\topacity: 0.2;\n\t\tposition: absolute;\n\t\ttop: 0vw;\n\t\tright: 0vw;\n\t\tpointer-events: none;\n\n\t}\n}\n\n\n.singleL {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tjustify-content: flex-end;\n\tgap: 2vw;\n}\n\n.rewardsBar {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tjustify-content: center;\n\tgap: 2vw;\n\twidth: 92vw;\n\tmargin: 3vw auto;\n}\n\n.headerBar {\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tjustify-content: space-between;\n\tgap: 2vw;\n\tbackground: transparent;\n}\n\n.accountsSub {\n\tmin-height: 30vw;\n\toverflow: hidden;\n\tborder-radius: 20px;\n\twidth: 100vw;\n\tmargin: 0 auto;\n\tmax-height: 70vw;\n}\n\n.headItem {\n\t// background: linear-gradient(180deg, var(--ion-color-primary) 0%, var(--ion-half-primary) 50%, var(--ion-pass-primary) 100%);\n\t// background-size: 200% 200%;\n\t// background-position: 0 0%;\n\t// backdrop-filter: blur(10px);\n\tposition: sticky;\n\ttop: 0;\n\tz-index: 3;\n\tdisplay: flex;\n\tflex-direction: column;\n}\n\n.themeSelector {\n\twidth: 30vw;\n}\n\n.titleMain{\n    font-size: 18px;\n    letter-spacing: 1px;\n    text-transform: capitalize;\n    font-weight: 400;\n    margin: 5vw 10vw 0;\n    display: flex\n;\n    justify-content: flex-start;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
